
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34959',
  depVersions: {
  "documents-public-ui": "static-1.34959",
  "atom": "static-1.5239",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2664",
  "client-types": "static-1.488",
  "cssUtils": "static-1.840",
  "customer-data-filters-ui": "static-1.40426",
  "customer-data-objects": "static-1.7844",
  "customer-data-property-utils": "static-1.8260",
  "documents-lib": "static-1.34964",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.351",
  "FormsCommonComponents": "static-1.86299",
  "FormUrlGenerator": "static-2.4886",
  "foundations-theming-specialty": "static-1.2318",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.106",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5759",
  "hs-test-utils": "static-1.8186",
  "hub-http": "static-1.6385",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11946",
  "HubStyleTokens": "static-2.11639",
  "I18n": "static-7.1644",
  "icons": "static-2.662",
  "jasmine-immutable": "static-1.3186",
  "jasmine-runner": "static-1.6621",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7316",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5560",
  "quartz": "static-1.7245",
  "react": "static-7.189",
  "react-dlb": "static-1.83",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1-track-cwv-per-soft-navigation.19",
  "react-select-plus": "static-1.107",
  "react-utils": "static-2.5460",
  "react-virtualized": "static-2.101",
  "reference-resolvers": "static-1.8341",
  "reference-resolvers-lite": "static-1.8262",
  "reporting-data": "static-1.68219",
  "reporting-reports": "static-1.67897",
  "reporting-snowflake": "static-1.56837",
  "reporting-testing-lib": "static-1.10152",
  "reporting-visualizations": "static-1.60295",
  "reselect": "static-3.7",
  "sales-content-partitioning": "static-1.9114",
  "sanitize": "static-1.4641",
  "sanitize-text": "static-1.8311",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1908",
  "signup-constants": "static-1.19281",
  "signup-ui-url-generator": "static-2.8222",
  "StyleGuideUI": "static-3.490",
  "superstore": "static-1.4924",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4923",
  "ui-addon-form-validation": "static-1.11155",
  "ui-asset-management-lib": "static-1.11247",
  "ui-images": "static-2.1201",
  "UIComponents": "static-3.8585",
  "usage-tracker": "static-1.7516",
  "usage-tracker-container": "static-1.7506",
  "usage-tracker-core": "static-1.7366",
  "viral-links-lib": "static-1.7236",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9823",
  "foundations-components": "static-1.8258",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1023",
  "quartz-core": "static-1.6464",
  "quick-fetch": "static-1.4036",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4823",
  "ui-addon-i18n": "static-1.11314",
  "ui-addon-upgrades": "static-9.18210",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3520",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3522",
  "quartz-webpack": "static-1.3469",
  "foundations-assets": "static-1.5039",
  "foundations-theming": "static-1.4602",
  "hub-http-shared-msw-handlers": "static-1.10381",
  "hubspotter-http": "static-1.4770",
  "sassPrefix": "static-1.159",
  "conversations-skeleton-state": "static-1.7412",
  "crm-message-bus": "static-1.43467",
  "customer-data-filters-ui-msw-helpers": "static-1.22861",
  "customer-data-objects-ui-components": "static-1.13195",
  "customer-data-reference-ui-components": "static-1.13341",
  "customer-data-ui-utilities": "static-1.9988",
  "events-data-lib": "static-1.402",
  "framework-builder-read-service-client": "static-1.4125",
  "framework-data-schema-quick-fetch": "static-1.6964",
  "framework-data-schema-resolvers": "static-1.7059",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3707",
  "inbound-db-properties-service-client": "static-1.3966",
  "multi-account-reference-resolvers": "static-1.1149",
  "onboarding-tours": "static-1.16920",
  "reporting-datasets-permissions-lib": "static-1.14173",
  "stylex": "static-1.36",
  "trellis-assets": "static-1.2265",
  "trellis-components": "static-1.2284",
  "trellis-theming": "static-1.1113",
  "ui-addon-teams": "static-1.21758",
  "quartz-auth": "static-1.920",
  "ui-business-units-lib": "static-1.9243",
  "usage-tracker-session-replay": "static-1.5202",
  "ai-components-ui-library": "static-1.9383",
  "ContentUtils": "static-1.68868",
  "customer-data-properties": "static-1.52146",
  "forms-ai-lib": "static-1.4577",
  "forms-utils-lib": "static-1.12894",
  "foundations-components-test-utils": "static-1.5741",
  "react-dnd-compat": "static-1.4779",
  "react-tinymce": "static-1.55700",
  "tinymce-config": "static-2.54826",
  "ui-gdpr-components": "static-1.10515",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3587",
  "HeadJS": "static-2.776",
  "framer-motion": "static-1.74",
  "hs-test-utils-bend-plugin": "static-1.3297",
  "msw": "static-1.39",
  "testing-library": "static-1.154",
  "hs-locale-management": "static-1.201",
  "ui-fonts": "static-1.901",
  "i18n-data": "static-1.224",
  "moment-timezone": "static-5.85",
  "jasmine": "static-4.4489",
  "csstype": "static-1.50",
  "quartz-head": "static-1.910",
  "web-vitals": "static-1.8",
  "batch-promise": "static-1.1708",
  "external-options-client-types": "static-1.4246",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.920",
  "frontend-preferences-client": "static-1.8093",
  "graphql": "static-1.84",
  "persist-promise": "static-1.3865",
  "reporting-client-types": "static-1.2599",
  "apollo-stack-hubspot": "static-3.88",
  "growth-payments-core": "static-1.25894",
  "hubspot-apollo-client": "static-1.5044",
  "foundations-components-legacy": "static-1.1283",
  "quartz-routing": "static-1.675",
  "hs-story-utils": "static-1.9588",
  "react-flip-move": "static-1.73",
  "nested-table": "static-1.403",
  "timezone-utils": "static-2.5408",
  "seat-types-lib": "static-1.393",
  "react-create-root-preference": "static-1.42",
  "bend-plugin-foundations-components": "static-1.4527",
  "floating-ui": "static-1.59",
  "react-aria": "static-1.68",
  "tanstack-table": "static-1.57",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.851",
  "mobile-manifest-mixins": "static-1.550",
  "module-federation": "static-1.28",
  "quartz-test": "static-1.920",
  "quartz-tracking": "static-1.624",
  "bend-plugin-chirp-manifest": "static-1.233",
  "chirp-fetch": "static-1.2053",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6158",
  "salesImages": "static-1.528",
  "ts-schema": "static-1.4201",
  "bender-build-tools": "static-1.3301",
  "bend-plugin-foundations-theming": "static-1.3085",
  "restore-request-side-panel-lib": "static-1.1346",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.344",
  "pulse": "static-1.776",
  "conditional-properties-service-client": "static-1.3917",
  "crm-pipelines-api-client-types": "static-1.4257",
  "fdsr-migration-layer": "static-1.178",
  "multi-currency-client-types": "static-1.3811",
  "getting-started-shared-tasks": "static-1.18917",
  "growth-data-modal": "static-1.5703",
  "growth-onboarding-confetti": "static-1.3230",
  "growth-onboarding-next-action-utils": "static-1.2421",
  "navigation-components": "static-1.18469",
  "onboarding-tours-client": "static-1.5134",
  "onboarding-tours-utils": "static-1.986",
  "ui-shepherd-react": "static-3.10426",
  "ui-shepherd-tracker": "static-1.7807",
  "ui-universal-auth": "static-1.9174",
  "user-context": "static-1.5274",
  "base-ui": "static-1.16",
  "react-day-picker": "static-1.5",
  "tanstack-virtual": "static-1.32",
  "hubspotter-http-shared-msw-handlers": "static-1.10379",
  "magpie-lib": "static-1.5660",
  "navigation-messaging": "static-1.7796",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22148",
  "copilot-toolkit": "static-1.11570",
  "cms-field-types": "static-1.4979",
  "content-icons-ui": "static-1.2276",
  "integrations-lib": "static-1.16700",
  "calling-global-api": "static-1.65096",
  "calling-internal-common": "static-1.31477",
  "calling-lifecycle-internal": "static-1.66478",
  "calling-lifecycle-messages": "static-1.58772",
  "commerce-products-lib": "static-1.10194",
  "crm-links": "static-1.6479",
  "customer-data-properties-shared-msw-handlers": "static-1.9708",
  "file-manager-components": "static-1.24119",
  "formula-editor": "static-1.14552",
  "google-libphonenumber": "static-1.40",
  "inbounddb-objects-service-types": "static-1.4337",
  "meetings-icalendar-utils-lib": "static-1.797",
  "object-builder-ui-client": "static-1.49302",
  "pipeline-validation-client-types": "static-1.4086",
  "property-value-citations": "static-1.2760",
  "smart-property-lib": "static-1.8044",
  "tiered-pricing": "static-1.1689",
  "topics-actions-lib": "static-1.304",
  "ui-addon-iframeable": "static-1.9241",
  "zustand": "static-1.74",
  "final-form": "static-1.72",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20124",
  "tinymce-themes": "static-1.56796",
  "data-token-picker": "static-1.16704",
  "hub-http-contrib": "static-1.3208",
  "interframe": "static-3.4921",
  "tinymce-data": "static-1.40911",
  "tinymce-plugins": "static-1.57940",
  "ui-addon-sales-email": "static-1.5376",
  "onboarding-scopes": "static-1.6624",
  "ui-addon-opt": "static-4.8525",
  "apollo-link-hub-http": "static-2.4816",
  "hubspot-apollo-cache": "static-1.503",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.338",
  "purchase-motions-api": "static-1.6161",
  "event-emitter": "static-1.1115",
  "bend-plugin-pulse": "static-1.279",
  "fast-json-patch": "static-1.65",
  "onboarding-data-sync-lib": "static-1.2252",
  "growth-onboarding-next-action-components": "static-1.2449",
  "user-context-client": "static-1.4718",
  "idb-keyval": "static-1.46",
  "magpie-types": "static-1.5120",
  "nest": "static-1.398",
  "reactive-lib": "static-1.889",
  "simple-logging-lib": "static-1.3214",
  "unified-auth-core-lib": "static-1.970",
  "getting-started-shared-tasks-store": "static-1.18035",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1318",
  "integrations-error-boundary-lib": "static-1.14115",
  "integrations-tracking-lib": "static-1.5771",
  "native-integrations-shared-strings": "static-1.7944",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10528",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.688",
  "calling-error-reporting": "static-1.31484",
  "shared-worker-versioning": "static-1.11200",
  "calling-usage-tracker": "static-1.6706",
  "voice-sms-access-library": "static-1.1613",
  "customer-data-tracking": "static-1.7048",
  "commerce-permissions": "static-1.940",
  "products-iframe-lib": "static-1.8342",
  "products-ui-components-shared-msw-handlers": "static-1.10763",
  "location-customization-utils-lib": "static-1.9759",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4315",
  "video-components-external": "static-1.11840",
  "video-data-lib": "static-1.35498",
  "bark-lib": "static-1.16636",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.97",
  "crm-properties-common-lib": "static-1.6053",
  "react-codemirror": "static-1.10795",
  "data-agent-kit": "static-1.461",
  "feedback-loader": "static-1.29610",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10464",
  "fsm": "static-1.3895",
  "policy-lib": "static-1.6950",
  "react-colorpicker": "static-2.10372",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10527",
  "FileManagerLib": "static-1.39759",
  "NamespacedHubStyle": "static-2.9173",
  "FileManagerCore": "static-1.39618",
  "content-assistance-lib": "static-1.8012",
  "layout-dnd-components": "static-1.12770",
  "layout-dnd-utils": "static-1.11745",
  "ui-addon-emoji-picker": "static-1.10048",
  "ui-brand-identity-lib": "static-1.15899",
  "InboxConnectUtils": "static-4.15275",
  "meetings-connect-utils-lib": "static-1.7771",
  "breeze-engine-core": "static-1.596",
  "ably": "static-2.2",
  "highlight.js": "static-1.81",
  "universal-page-editor-lib": "static-1.3177",
  "adobe-sign-auth-lib": "static-1.183",
  "ads-unified-auth-lib": "static-1.666",
  "google-sheets-integration-lib": "static-1.746",
  "microsoft-drive-integration-lib": "static-1.878",
  "surveymonkey-integration-lib": "static-1.199",
  "slack-ui-library": "static-1.10562",
  "calling-orchestration-schema": "static-1.36390",
  "sales-views-client-types": "static-1.4422",
  "crm-record-cards-service-types": "static-1.3703",
  "content-media-composition-data-lib": "static-1.12868",
  "content-media-compositions": "static-2.16875",
  "media-bridge-lib": "static-1.19220",
  "react-reducer-toolkit": "static-1.16072",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4672",
  "storybook-react": "static-1.35",
  "audio-components": "static-1.6168",
  "FileManagerImages": "static-1.37270",
  "video-components": "static-1.13842",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.56",
  "urlinator": "static-1.4697",
  "video-embed": "static-1.36332",
  "ui-addon-video-player": "static-1.8869",
  "ui-coaching-tips": "static-1.29039",
  "ContentData": "static-1.68943",
  "layout-data-lib": "static-1.10070",
  "social-insights-client-types": "static-1.22524",
  "outpost": "static-1.4333",
  "growth-onboarding-feedback-components": "static-1.6744",
  "advanced-menus-core": "static-1.15407",
  "advanced-menus-lib": "static-1.12304",
  "ExportDialog": "static-6.10543",
  "ui-memberships-settings-lib": "static-1.34513",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15406",
  "simple-menus-lib": "static-1.16923"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34959",
  "atom": "/atom/static-1.5239",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2664",
  "client-types": "/client-types/static-1.488",
  "cssUtils": "/cssUtils/static-1.840",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40426",
  "customer-data-objects": "/customer-data-objects/static-1.7844",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8260",
  "documents-lib": "/documents-lib/static-1.34964",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.351",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86299",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4886",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2318",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.106",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5759",
  "hs-test-utils": "/hs-test-utils/static-1.8186",
  "hub-http": "/hub-http/static-1.6385",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11946",
  "HubStyleTokens": "/HubStyleTokens/static-2.11639",
  "I18n": "/I18n/static-7.1644",
  "icons": "/icons/static-2.662",
  "jasmine-immutable": "/jasmine-immutable/static-1.3186",
  "jasmine-runner": "/jasmine-runner/static-1.6621",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7316",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5560",
  "quartz": "/quartz/static-1.7245",
  "react": "/react/static-7.189",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1-track-cwv-per-soft-navigation.19",
  "react-select-plus": "/react-select-plus/static-1.107",
  "react-utils": "/react-utils/static-2.5460",
  "react-virtualized": "/react-virtualized/static-2.101",
  "reference-resolvers": "/reference-resolvers/static-1.8341",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8262",
  "reporting-data": "/reporting-data/static-1.68219",
  "reporting-reports": "/reporting-reports/static-1.67897",
  "reporting-snowflake": "/reporting-snowflake/static-1.56837",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10152",
  "reporting-visualizations": "/reporting-visualizations/static-1.60295",
  "reselect": "/reselect/static-3.7",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9114",
  "sanitize": "/sanitize/static-1.4641",
  "sanitize-text": "/sanitize-text/static-1.8311",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1908",
  "signup-constants": "/signup-constants/static-1.19281",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8222",
  "StyleGuideUI": "/StyleGuideUI/static-3.490",
  "superstore": "/superstore/static-1.4924",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4923",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11155",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11247",
  "ui-images": "/ui-images/static-2.1201",
  "UIComponents": "/UIComponents/static-3.8585",
  "usage-tracker": "/usage-tracker/static-1.7516",
  "usage-tracker-container": "/usage-tracker-container/static-1.7506",
  "usage-tracker-core": "/usage-tracker-core/static-1.7366",
  "viral-links-lib": "/viral-links-lib/static-1.7236",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9823",
  "foundations-components": "/foundations-components/static-1.8258",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1023",
  "quartz-core": "/quartz-core/static-1.6464",
  "quick-fetch": "/quick-fetch/static-1.4036",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4823",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11314",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18210",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3520",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3522",
  "quartz-webpack": "/quartz-webpack/static-1.3469",
  "foundations-assets": "/foundations-assets/static-1.5039",
  "foundations-theming": "/foundations-theming/static-1.4602",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10381",
  "hubspotter-http": "/hubspotter-http/static-1.4770",
  "sassPrefix": "/sassPrefix/static-1.159",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7412",
  "crm-message-bus": "/crm-message-bus/static-1.43467",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22861",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13195",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13341",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9988",
  "events-data-lib": "/events-data-lib/static-1.402",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4125",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6964",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7059",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3707",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3966",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1149",
  "onboarding-tours": "/onboarding-tours/static-1.16920",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14173",
  "stylex": "/stylex/static-1.36",
  "trellis-assets": "/trellis-assets/static-1.2265",
  "trellis-components": "/trellis-components/static-1.2284",
  "trellis-theming": "/trellis-theming/static-1.1113",
  "ui-addon-teams": "/ui-addon-teams/static-1.21758",
  "quartz-auth": "/quartz-auth/static-1.920",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9243",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5202",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9383",
  "ContentUtils": "/ContentUtils/static-1.68868",
  "customer-data-properties": "/customer-data-properties/static-1.52146",
  "forms-ai-lib": "/forms-ai-lib/static-1.4577",
  "forms-utils-lib": "/forms-utils-lib/static-1.12894",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5741",
  "react-dnd-compat": "/react-dnd-compat/static-1.4779",
  "react-tinymce": "/react-tinymce/static-1.55700",
  "tinymce-config": "/tinymce-config/static-2.54826",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10515",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3587",
  "HeadJS": "/HeadJS/static-2.776",
  "framer-motion": "/framer-motion/static-1.74",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3297",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.154",
  "hs-locale-management": "/hs-locale-management/static-1.201",
  "ui-fonts": "/ui-fonts/static-1.901",
  "i18n-data": "/i18n-data/static-1.224",
  "moment-timezone": "/moment-timezone/static-5.85",
  "jasmine": "/jasmine/static-4.4489",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.910",
  "web-vitals": "/web-vitals/static-1.8",
  "batch-promise": "/batch-promise/static-1.1708",
  "external-options-client-types": "/external-options-client-types/static-1.4246",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.920",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8093",
  "graphql": "/graphql/static-1.84",
  "persist-promise": "/persist-promise/static-1.3865",
  "reporting-client-types": "/reporting-client-types/static-1.2599",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.88",
  "growth-payments-core": "/growth-payments-core/static-1.25894",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5044",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1283",
  "quartz-routing": "/quartz-routing/static-1.675",
  "hs-story-utils": "/hs-story-utils/static-1.9588",
  "react-flip-move": "/react-flip-move/static-1.73",
  "nested-table": "/nested-table/static-1.403",
  "timezone-utils": "/timezone-utils/static-2.5408",
  "seat-types-lib": "/seat-types-lib/static-1.393",
  "react-create-root-preference": "/react-create-root-preference/static-1.42",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4527",
  "floating-ui": "/floating-ui/static-1.59",
  "react-aria": "/react-aria/static-1.68",
  "tanstack-table": "/tanstack-table/static-1.57",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.851",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.550",
  "module-federation": "/module-federation/static-1.28",
  "quartz-test": "/quartz-test/static-1.920",
  "quartz-tracking": "/quartz-tracking/static-1.624",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.233",
  "chirp-fetch": "/chirp-fetch/static-1.2053",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6158",
  "salesImages": "/salesImages/static-1.528",
  "ts-schema": "/ts-schema/static-1.4201",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3085",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1346",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.344",
  "pulse": "/pulse/static-1.776",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3917",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4257",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.178",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3811",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18917",
  "growth-data-modal": "/growth-data-modal/static-1.5703",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3230",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2421",
  "navigation-components": "/navigation-components/static-1.18469",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5134",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.986",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10426",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7807",
  "ui-universal-auth": "/ui-universal-auth/static-1.9174",
  "user-context": "/user-context/static-1.5274",
  "base-ui": "/base-ui/static-1.16",
  "react-day-picker": "/react-day-picker/static-1.5",
  "tanstack-virtual": "/tanstack-virtual/static-1.32",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10379",
  "magpie-lib": "/magpie-lib/static-1.5660",
  "navigation-messaging": "/navigation-messaging/static-1.7796",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22148",
  "copilot-toolkit": "/copilot-toolkit/static-1.11570",
  "cms-field-types": "/cms-field-types/static-1.4979",
  "content-icons-ui": "/content-icons-ui/static-1.2276",
  "integrations-lib": "/integrations-lib/static-1.16700",
  "calling-global-api": "/calling-global-api/static-1.65096",
  "calling-internal-common": "/calling-internal-common/static-1.31477",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66478",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58772",
  "commerce-products-lib": "/commerce-products-lib/static-1.10194",
  "crm-links": "/crm-links/static-1.6479",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9708",
  "file-manager-components": "/file-manager-components/static-1.24119",
  "formula-editor": "/formula-editor/static-1.14552",
  "google-libphonenumber": "/google-libphonenumber/static-1.40",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4337",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.797",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49302",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4086",
  "property-value-citations": "/property-value-citations/static-1.2760",
  "smart-property-lib": "/smart-property-lib/static-1.8044",
  "tiered-pricing": "/tiered-pricing/static-1.1689",
  "topics-actions-lib": "/topics-actions-lib/static-1.304",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9241",
  "zustand": "/zustand/static-1.74",
  "final-form": "/final-form/static-1.72",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20124",
  "tinymce-themes": "/tinymce-themes/static-1.56796",
  "data-token-picker": "/data-token-picker/static-1.16704",
  "hub-http-contrib": "/hub-http-contrib/static-1.3208",
  "interframe": "/interframe/static-3.4921",
  "tinymce-data": "/tinymce-data/static-1.40911",
  "tinymce-plugins": "/tinymce-plugins/static-1.57940",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5376",
  "onboarding-scopes": "/onboarding-scopes/static-1.6624",
  "ui-addon-opt": "/ui-addon-opt/static-4.8525",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4816",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.503",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.338",
  "purchase-motions-api": "/purchase-motions-api/static-1.6161",
  "event-emitter": "/event-emitter/static-1.1115",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.279",
  "fast-json-patch": "/fast-json-patch/static-1.65",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2252",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2449",
  "user-context-client": "/user-context-client/static-1.4718",
  "idb-keyval": "/idb-keyval/static-1.46",
  "magpie-types": "/magpie-types/static-1.5120",
  "nest": "/nest/static-1.398",
  "reactive-lib": "/reactive-lib/static-1.889",
  "simple-logging-lib": "/simple-logging-lib/static-1.3214",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.970",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18035",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1318",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14115",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5771",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7944",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10528",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.688",
  "calling-error-reporting": "/calling-error-reporting/static-1.31484",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11200",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6706",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1613",
  "customer-data-tracking": "/customer-data-tracking/static-1.7048",
  "commerce-permissions": "/commerce-permissions/static-1.940",
  "products-iframe-lib": "/products-iframe-lib/static-1.8342",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10763",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9759",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4315",
  "video-components-external": "/video-components-external/static-1.11840",
  "video-data-lib": "/video-data-lib/static-1.35498",
  "bark-lib": "/bark-lib/static-1.16636",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.97",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6053",
  "react-codemirror": "/react-codemirror/static-1.10795",
  "data-agent-kit": "/data-agent-kit/static-1.461",
  "feedback-loader": "/feedback-loader/static-1.29610",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10464",
  "fsm": "/fsm/static-1.3895",
  "policy-lib": "/policy-lib/static-1.6950",
  "react-colorpicker": "/react-colorpicker/static-2.10372",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10527",
  "FileManagerLib": "/FileManagerLib/static-1.39759",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9173",
  "FileManagerCore": "/FileManagerCore/static-1.39618",
  "content-assistance-lib": "/content-assistance-lib/static-1.8012",
  "layout-dnd-components": "/layout-dnd-components/static-1.12770",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11745",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10048",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15899",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15275",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7771",
  "breeze-engine-core": "/breeze-engine-core/static-1.596",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.81",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3177",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.183",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.666",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.746",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.878",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.199",
  "slack-ui-library": "/slack-ui-library/static-1.10562",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36390",
  "sales-views-client-types": "/sales-views-client-types/static-1.4422",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3703",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12868",
  "content-media-compositions": "/content-media-compositions/static-2.16875",
  "media-bridge-lib": "/media-bridge-lib/static-1.19220",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16072",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4672",
  "storybook-react": "/storybook-react/static-1.35",
  "audio-components": "/audio-components/static-1.6168",
  "FileManagerImages": "/FileManagerImages/static-1.37270",
  "video-components": "/video-components/static-1.13842",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.56",
  "urlinator": "/urlinator/static-1.4697",
  "video-embed": "/video-embed/static-1.36332",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8869",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29039",
  "ContentData": "/ContentData/static-1.68943",
  "layout-data-lib": "/layout-data-lib/static-1.10070",
  "social-insights-client-types": "/social-insights-client-types/static-1.22524",
  "outpost": "/outpost/static-1.4333",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6744",
  "advanced-menus-core": "/advanced-menus-core/static-1.15407",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12304",
  "ExportDialog": "/ExportDialog/static-6.10543",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34513",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15406",
  "simple-menus-lib": "/simple-menus-lib/static-1.16923"
}
};
